var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "container-fluid border-0 mb-0 shadow-none projectGantt pb-5 px-0",
    },
    [
      _c(
        "portal",
        { attrs: { to: "sidebar" } },
        [
          _c("rates", {
            attrs: {
              show: _vm.showRates,
              fullWidth: false,
              project: _vm.project,
              task: _vm.selectedTask,
            },
            on: {
              outSideClicked: function ($event) {
                _vm.showRates = false
              },
              rateSelected: _vm.onRateSelected,
            },
          }),
        ],
        1
      ),
      _vm.showRequirement
        ? _c(
            "portal",
            { attrs: { to: "sidebar" } },
            [
              _c("requirement", {
                attrs: {
                  show: _vm.showRequirement,
                  fullWidth: false,
                  project: _vm.project,
                  editId: (_vm.selectedTask || {}).id,
                },
                on: {
                  outSideClicked: function ($event) {
                    _vm.showRequirement = false
                  },
                  taskCreated: function ($event) {
                    ;(_vm.showRequirement = false), _vm.$emit("taskCreated")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.project && _vm.showFinance
        ? _c(
            "portal",
            { attrs: { to: "sidebar" } },
            [
              _c("finance", {
                attrs: {
                  show: _vm.showFinance,
                  fullWidth: false,
                  project: _vm.project,
                  task: _vm.selectedTask,
                },
                on: {
                  outSideClicked: function ($event) {
                    _vm.showFinance = false
                  },
                  paymentSuccess: _vm._onPaymentSuccess,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("user-picker-modal", {
        attrs: {
          _key: 0,
          visible: _vm.modals.contributors,
          "modal-title": "Key People",
          role: "CONTRIBUTOR",
          multi: true,
          skipList: _vm.skipList,
          saveOnUserSelect: false,
          defaults: [_vm.project.user_owner],
        },
        on: {
          input: _vm._onContributerUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.contributors = false
          },
        },
        model: {
          value: _vm.contributors,
          callback: function ($$v) {
            _vm.contributors = $$v
          },
          expression: "contributors",
        },
      }),
      _c("user-picker-modal", {
        attrs: {
          _key: 1,
          visible: _vm.modals.viewers,
          "modal-title": "Watchers",
          role: "VIEWER",
          multi: true,
          skipList: _vm.skipList,
          saveOnUserSelect: false,
        },
        on: {
          input: _vm._onViewersChanged,
          closeClicked: function ($event) {
            _vm.modals.viewers = false
          },
        },
        model: {
          value: _vm.viewers,
          callback: function ($$v) {
            _vm.viewers = $$v
          },
          expression: "viewers",
        },
      }),
      _c("user-picker-modal", {
        attrs: {
          _key: 2,
          visible: _vm.modals.approvers,
          "modal-title": "Approvers",
          role: "APPROVER",
          multi: true,
          skipList: _vm.skipListApprovers,
          saveOnUserSelect: false,
        },
        on: {
          input: _vm._onApproversChanged,
          closeClicked: function ($event) {
            _vm.modals.approvers = false
          },
        },
        model: {
          value: _vm.approvers,
          callback: function ($$v) {
            _vm.approvers = $$v
          },
          expression: "approvers",
        },
      }),
      _c("user-picker-modal", {
        attrs: {
          _key: 3,
          visible: _vm.modals.projectApprovers,
          "modal-title": "Approvers",
          role: "APPROVER",
          multi: true,
          skipList: _vm.skipListProjectApprovers,
          saveOnUserSelect: false,
        },
        on: {
          input: _vm._onProjectApproversChanged,
          closeClicked: function ($event) {
            _vm.modals.projectApprovers = false
          },
        },
        model: {
          value: _vm.projectApprovers,
          callback: function ($$v) {
            _vm.projectApprovers = $$v
          },
          expression: "projectApprovers",
        },
      }),
      _c(
        "div",
        { staticClass: "card card-table shadow-sm border-0 rounded-0" },
        [
          _c(
            "div",
            {
              staticClass:
                "card-header border-bottom-0 d-flex justify-content-between",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c("h6", { staticClass: "text-warning mb-0 pr-2" }, [
                    _vm._v("Status"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-row justify-content-between align-items-center",
                    },
                    [
                      _c(
                        "base-radio",
                        {
                          staticClass: "mr-3",
                          attrs: { name: "All" },
                          on: { click: _vm.onFilterChanged },
                          model: {
                            value: _vm.filter.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "status", $$v)
                            },
                            expression: "filter.status",
                          },
                        },
                        [_vm._v("\n            All\n          ")]
                      ),
                      _c(
                        "base-radio",
                        {
                          staticClass: "mr-3",
                          attrs: { name: "Quoted" },
                          on: { click: _vm.onFilterChanged },
                          model: {
                            value: _vm.filter.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "status", $$v)
                            },
                            expression: "filter.status",
                          },
                        },
                        [_vm._v("\n            Quoted\n          ")]
                      ),
                      _c(
                        "base-radio",
                        {
                          staticClass: "mr-3",
                          attrs: { name: "Approved" },
                          on: { click: _vm.onFilterChanged },
                          model: {
                            value: _vm.filter.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "status", $$v)
                            },
                            expression: "filter.status",
                          },
                        },
                        [_vm._v("\n            Approved\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "ul",
                { staticClass: "pl-0 mb-0 d-flex mr-2 font-size-zero" },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "mr-4 font-size-zero d-inline-flex align-items-center",
                    },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: `Approvers`,
                              expression: "`Approvers`",
                              modifiers: { "top-center": true },
                            },
                          ],
                          staticClass:
                            "d-inline-block icn-notification position-relative font-size-zero lh-1",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              _vm.modals.projectApprovers = true
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "icn-svg icn-key lh-1 test22" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icn-svg-full",
                                  staticStyle: {
                                    "enable-background": "new 0 0 20 20",
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    "xml:space": "preserve",
                                  },
                                },
                                [
                                  _c("path", {
                                    staticStyle: { fill: "#5603ad" },
                                    attrs: {
                                      d: "M10 0c-.2 0-.3 0-.3.1-.1 0-.1.1-.2.1-.2 0-.3.1-.4.2-.3.1-.7.4-1 .6l-1 .6c-.1.1-.3.1-.4.2h-.1c.1 0 .1 0 0 0s-.1 0 0 0h-.1l-.3.2-1.2.2c-.4.1-.8.2-1.1.3-.2.1-.4.1-.6.2-.1 0-.1 0-.3.2-.2.2-.2.3-.3.3 0 .2-.1.4-.2.7-.1.3-.2.7-.3 1.1L2 6.1c0 .1-.1.3-.1.4v.1c0-.1 0-.1 0 0s0 .1 0 0c-.1.1-.2.3-.3.4L1 8c-.2.4-.4.7-.6 1-.1.2-.2.3-.2.4 0 .1-.1.1-.1.2-.1.1-.1.1-.1.4 0 .3 0 .3.1.4 0 .1.1.1.1.2.1.1.1.3.2.4.2.3.4.7.6 1l.6 1 .2.3v.1c0-.1 0-.1 0 0s0 .1 0 0v.1l.2.3.2 1.2c.1.4.2.8.3 1.1.1.2.1.4.2.6 0 .1 0 .1.2.3.2.2.2.2.3.2.2.1.4.1.6.2.3.1.7.2 1.1.3l1.2.3.4.1h.1c-.1 0-.1 0 0 0s.1 0 0 0c.1.1.3.2.4.3l1 .6c.4.2.7.4 1 .6.1.1.3.2.4.2.1 0 .1.1.2.1.1.1.1.1.4.1.3 0 .3 0 .4-.1.1 0 .1-.1.2-.1.1-.1.3-.1.4-.2.3-.2.7-.4 1-.6l1-.6.3-.2h.1c-.1 0-.1 0 0 0s.1 0 0 0h.1l.4-.1c.3-.1.7-.2 1.1-.3.4-.1.8-.2 1.1-.3.2-.1.4-.1.6-.2.1 0 .1 0 .3-.2.2-.2.2-.2.2-.3.1-.2.1-.4.2-.6.1-.3.2-.7.3-1.1L18 14l.1-.4v-.1c0 .1 0 .1 0 0s0-.1 0 0c.1-.1.2-.3.3-.4l.6-1c.2-.4.4-.7.6-1 .1-.1.2-.3.2-.4 0-.1.1-.1.1-.2s.1-.1.1-.4c0-.3 0-.3-.1-.4 0-.1-.1-.1-.1-.2-.1-.1-.1-.3-.2-.4-.2-.3-.4-.7-.6-1l-.6-1c-.1-.1-.1-.2-.2-.3v-.1c0 .1 0 .1 0 0s0-.1 0 0v-.1l-.2-.4-.2-1.2c-.1-.4-.2-.8-.3-1.1-.1-.2-.1-.4-.2-.6 0-.1 0-.1-.2-.3-.2-.2-.2-.2-.3-.2-.2-.1-.4-.1-.6-.2-.3-.1-.7-.2-1.1-.3L13.9 2c-.1 0-.3-.1-.4-.1h-.1c.1 0 .1 0 0 0s-.1 0 0 0c-.1-.1-.3-.2-.4-.3L12 1c-.4-.2-.7-.4-1-.6-.1-.1-.3-.2-.4-.2-.1 0-.1-.1-.2-.1-.1-.1-.1-.1-.4-.1zm0 1.8.1.1c.3.2.6.4 1 .6l1 .6.4.2c.1.1.1.1.3.2.2.1.2.1.3.1l.4.1 1.1.3c.4 0 .8.1 1.1.1h.1v.1c.2.4.3.8.4 1.2.1.4.2.8.3 1.1V7c0 .1 0 .1.1.3.1.2.1.2.2.3l.2.4.6 1c.2.3.4.7.6 1l.1.1c-.2.4-.4.7-.7 1.1l-.6 1c-.1.1-.2.2-.2.4-.1.1-.1.1-.2.3-.1.2-.1.2-.1.3l-.1.4-.3 1.1c-.1.4-.2.8-.3 1.1v.1h-.1c-.3.1-.7.2-1.1.3-.4.1-.8.2-1.1.3-.1 0-.3.1-.4.1-.1 0-.1 0-.3.1-.2.1-.2.1-.3.2-.1.1-.2.1-.4.2l-1 .6c-.3.2-.7.4-1 .6H10c-.4-.2-.7-.4-1.1-.7l-1-.6c-.1-.1-.2-.2-.4-.2-.1-.1-.1-.1-.3-.2-.2-.1-.2-.1-.3-.1-.1 0-.3-.1-.4-.1l-1.1-.3c-.4 0-.7-.1-1.1-.2h-.1v-.1c-.2-.4-.3-.8-.4-1.2l-.3-1.1c0-.1-.1-.3-.1-.4 0-.1 0-.1-.1-.3-.1-.2-.1-.2-.2-.3-.1-.1-.1-.2-.2-.4-.2-.3-.4-.6-.6-1-.2-.3-.4-.6-.6-1V10l.1-.1c.2-.3.4-.6.6-1l.6-1 .2-.4c.1-.1.1-.1.2-.3.1-.1.1-.2.1-.3l.1-.4.3-1.1c.1-.4.2-.8.2-1.1v-.1h.1c.4-.2.8-.3 1.2-.4.4-.1.8-.2 1.1-.3.1 0 .3-.1.4-.1.1 0 .1 0 .3-.1.2-.1.2-.1.3-.2l.4-.1 1-.6c.3-.2.6-.4 1-.6h.1zm3.6 4.6c-.2 0-.4.1-.6.3l-4 4.6-1.8-1.5c-.3-.3-.9-.3-1.2.1-.3.4-.3.9.1 1.2l2.4 2c.3.3.9.3 1.2-.1l4.6-5.2c.3-.3.3-.9-.1-1.2-.2-.1-.4-.2-.6-.2z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "icn-badge bg-info-two" }, [
                            _vm._v(
                              _vm._s(
                                (_vm.project.approvers &&
                                  _vm.project.approvers.length) ||
                                  0
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      staticClass:
                        "mr-4 font-size-zero d-inline-flex align-items-center",
                    },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: `Key People`,
                              expression: "`Key People`",
                              modifiers: { "top-center": true },
                            },
                          ],
                          staticClass:
                            "d-inline-block icn-notification position-relative font-size-zero lh-1",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              _vm.modals.contributors = true
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "icn-svg icn-key lh-1 te222y" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icn-svg-full",
                                  staticStyle: {
                                    "enable-background": "new 0 0 22.1 22.3",
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    x: "0",
                                    y: "0",
                                    viewBox: "0 0 22.1 22.3",
                                    "xml:space": "preserve",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "#2dce89",
                                      d: "M14 9.3c.6-2.1.3-4.3-.9-6.1C11.9 1.4 10 .2 7.8 0 5.7-.2 3.6.6 2.1 2.1S-.2 5.8 0 7.9C.2 10 1.3 12 3.1 13.2c1.8 1.2 4 1.5 6 .9l2.7 2.7c.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h3.9c.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5v-3.9c0-.2-.1-.3-.2-.5l-7.9-8zM20.8 21h-2.6v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-1.9v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-2.3l-2.8-2.8c-.2-.2-.4-.2-.7-.2-1.7.6-3.5.4-5.1-.5-1.5-.9-2.5-2.5-2.7-4.3C1.1 6.1 1.8 4.3 3 3s3-1.9 4.8-1.7c1.8.2 3.4 1.2 4.3 2.8.9 1.5 1.1 3.4.5 5.1-.1.2 0 .5.2.7l8 8.1v3z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#2dce89",
                                      d: "M4.3 4.7c-.4.4-.6.9-.6 1.5s.2 1.1.7 1.5c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.4-.4.7-.9.7-1.5s-.4-1.1-.8-1.5c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6zm2.1 2c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.4.1.5.2c.2.1.2.3.2.5s0 .4-.2.5z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "icn-badge bg-success" }, [
                            _vm._v(
                              _vm._s(
                                (_vm.project.contributors &&
                                  _vm.project.contributors.length + 1) ||
                                  0
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      staticClass:
                        "font-size-zero lh-1 d-inline-flex align-items-center",
                    },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: `Watchers`,
                              expression: "`Watchers`",
                              modifiers: { "top-center": true },
                            },
                          ],
                          staticClass:
                            "d-inline-block icn-notification position-relative font-size-zero lh-1",
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              _vm.modals.viewers = true
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "icn-svg icn-eye font-size-zero lh-1",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icn-svg-full",
                                  staticStyle: {
                                    "enable-background": "new 0 0 28.1 18.2",
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    x: "0",
                                    y: "0",
                                    viewBox: "0 0 28.1 18.2",
                                    "xml:space": "preserve",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "#fb6340",
                                      d: "M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#fb6340",
                                      d: "M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "icn-badge bg-alert" }, [
                            _vm._v(
                              _vm._s(
                                (_vm.project.viewers &&
                                  _vm.project.viewers.length) ||
                                  0
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "card-body px-0 pt-0 pb-0" }, [
            _c("div", { staticClass: "table-responsive p-0" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table align-items-center justify-content-center mb-0 table-custom-one",
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _vm._m(0),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-start align-items-center lh-1",
                            },
                            [
                              _vm._v(
                                "\n                  Requirement\n                  "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "icn-svg icn-sorting ml-1 lh-1",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icn-svg-full",
                                      attrs: {
                                        width: "8",
                                        height: "12",
                                        viewBox: "0 0 8 12",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          "clip-rule": "evenodd",
                                          d: "M3.80439 0.203125L7.52283 4.58268H0.0859375L3.80439 0.203125ZM3.80439 11.152L0.0859375 6.77245H7.52283L3.80439 11.152Z",
                                          fill: "#8898AA",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                        },
                        [_vm._v("\n                Rate\n              ")]
                      ),
                      _vm.profile.quoteCalculationInterval == "DAY"
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                            },
                            [_vm._v("\n                Days\n              ")]
                          )
                        : _vm._e(),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                        },
                        [_vm._v("\n                Team\n              ")]
                      ),
                      _vm.profile.quoteCalculationInterval == "HOUR"
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                            },
                            [_vm._v("\n                Hours\n              ")]
                          )
                        : _vm._e(),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                        },
                        [_vm._v("\n                Months\n              ")]
                      ),
                      _vm._m(1),
                      _vm._m(2),
                      _vm._m(3),
                      _c(
                        "th",
                        {
                          staticClass:
                            "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("span", [_vm._v("Description")]),
                              _c(
                                "label",
                                {
                                  staticClass: "switch mb-0 mx-2",
                                  attrs: { for: "switchEOT" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "icn-svg icn-switch ml-1" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.expandedEOT,
                                            expression: "expandedEOT",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "switchEOT",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.expandedEOT
                                          )
                                            ? _vm._i(_vm.expandedEOT, null) > -1
                                            : _vm.expandedEOT,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.expandedEOT,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.expandedEOT = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.expandedEOT = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.expandedEOT = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "icn-svg-full",
                                          attrs: {
                                            width: "140",
                                            height: "16",
                                            viewBox: "0 0 140 50",
                                          },
                                        },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              x: "5",
                                              y: "-8",
                                              rx: "33",
                                              width: "134",
                                              height: "66",
                                              "stroke-width": "0px",
                                            },
                                          }),
                                          _c("circle", {
                                            attrs: {
                                              cy: "25",
                                              fill: "#ffffff",
                                              stroke: "black",
                                              "stroke-width": "0px",
                                              r: "23",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("span", [_vm._v("Expand")]),
                            ]
                          ),
                        ]
                      ),
                      false
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light text-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center lh-1",
                                },
                                [
                                  _vm._v(
                                    "\n                  Approvees\n                  "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "icn-svg icn-sorting ml-1" },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "icn-svg-full",
                                          attrs: {
                                            width: "8",
                                            height: "12",
                                            viewBox: "0 0 8 12",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              "fill-rule": "evenodd",
                                              "clip-rule": "evenodd",
                                              d: "M3.80439 0.203125L7.52283 4.58268H0.0859375L3.80439 0.203125ZM3.80439 11.152L0.0859375 6.77245H7.52283L3.80439 11.152Z",
                                              fill: "#8898AA",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._m(4),
                      _c("th", { staticClass: "bg-light" }),
                    ]),
                  ]),
                  _vm.openTasks
                    ? _c(
                        "tbody",
                        [
                          _vm._l(_vm.openTasks, function (task, ind) {
                            return _c(
                              "tr",
                              {
                                key: ind,
                                style: {
                                  background:
                                    task.approval_status == "QUOTED"
                                      ? "#f2fff2"
                                      : task.approval_status == "APPROVED" &&
                                        task.payment_status == "OVERDUE"
                                      ? "#faebeb"
                                      : "white",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectedTask = task
                                  },
                                },
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "padding-right": "0px",
                                      "padding-left": "0px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center tyyy",
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("user-avatar-small", {
                                              attrs: {
                                                data: task.assignedBy,
                                                disableEdit: true,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("td", [
                                  _vm.canEditDescription(task)
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: task.name,
                                            expression: "task.name",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control--inside-tbl form-control--new-requirement w-100",
                                        attrs: {
                                          rows: "3",
                                          placeholder: _vm.placeholder,
                                        },
                                        domProps: { value: task.name },
                                        on: {
                                          focus: function ($event) {
                                            _vm.placeholder = ""
                                          },
                                          blur: function ($event) {
                                            return _vm._onDescriptionBlur(task)
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              task,
                                              "name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "0.74rem",
                                          },
                                        },
                                        [_vm._v(_vm._s(task.name))]
                                      ),
                                ]),
                                _c("td", [
                                  task.hourly_cost && task.hourly_cost != 0
                                    ? _c(
                                        "span",
                                        {
                                          on: {
                                            click: function ($event) {
                                              _vm.editIndex = ind
                                              _vm.showRates = _vm.canEdit(task)
                                              _vm.selectedTask = task
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.profile.currency &&
                                                _vm.profile.currency.symbol
                                            ) +
                                              _vm._s(task.hourly_cost) +
                                              "\n                  " +
                                              _vm._s(
                                                _vm.profile.currency &&
                                                  _vm.profile.currency.value
                                              ) +
                                              "/HR"
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-dot-action text-default border-0 mb-0 p-0",
                                          on: {
                                            click: function ($event) {
                                              _vm.editIndex = ind
                                              _vm.showRates = _vm.canEdit(task)
                                              _vm.selectedTask = task
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-ellipsis-h text-xs",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                ]),
                                _vm.profile.quoteCalculationInterval == "DAY"
                                  ? _c("td", [
                                      _vm.canEdit(task)
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: task.no_of_days,
                                                expression: "task.no_of_days",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control--inside-tbl form-control--input-width-small form-control--placeholder-text-lg",
                                            attrs: { placeholder: "..." },
                                            domProps: {
                                              value: task.no_of_days,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm._updateTask(task)
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  task,
                                                  "no_of_days",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(task.no_of_days)),
                                          ]),
                                    ])
                                  : _vm._e(),
                                _c("td", [
                                  _vm.canEdit(task)
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: task.total_team_members,
                                            expression:
                                              "task.total_team_members",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control--inside-tbl form-control--input-width-small form-control--placeholder-text-lg",
                                        attrs: { placeholder: "..." },
                                        domProps: {
                                          value: task.total_team_members,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              task,
                                              "total_team_members",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _c("span", [
                                        _vm._v(_vm._s(task.total_team_members)),
                                      ]),
                                ]),
                                _vm.profile.quoteCalculationInterval == "HOUR"
                                  ? _c("td", [
                                      _vm.canEdit(task)
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: task.quoted_hours,
                                                expression: "task.quoted_hours",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control--inside-tbl form-control--input-width-small",
                                            attrs: { rows: "3" },
                                            domProps: {
                                              value: task.quoted_hours,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm._updateTask(task)
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  task,
                                                  "quoted_hours",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(task.quoted_hours)),
                                          ]),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "td",
                                  [
                                    _vm.canEdit(task)
                                      ? _c(
                                          "el-select",
                                          {
                                            staticClass:
                                              "radius-0 select-small border-0 form-control--inside-tbl form-control--input-width-small",
                                            attrs: {
                                              size: "small",
                                              "value-key": "value",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm._updateTask(task)
                                              },
                                            },
                                            model: {
                                              value: task.mbs_months,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  task,
                                                  "mbs_months",
                                                  $$v
                                                )
                                              },
                                              expression: "task.mbs_months",
                                            },
                                          },
                                          _vm._l(
                                            [
                                              { value: 1, label: "-" },
                                              { value: 2, label: "2" },
                                              { value: 3, label: "3" },
                                              { value: 4, label: "4" },
                                              { value: 5, label: "5" },
                                              { value: 6, label: "6" },
                                              { value: 7, label: "7" },
                                              { value: 8, label: "8" },
                                              { value: 9, label: "9" },
                                              { value: 10, label: "10" },
                                              { value: 11, label: "11" },
                                              { value: 12, label: "12" },
                                            ],
                                            function (option, index) {
                                              return _c("el-option", {
                                                key: index,
                                                staticClass: "select-danger",
                                                attrs: {
                                                  label: option.label,
                                                  value: option.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              task.mbs_months < 2
                                                ? "-"
                                                : task.mbs_months
                                            )
                                          ),
                                        ]),
                                  ],
                                  1
                                ),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalCost(task).costFormatted
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalCost(task).gstFormatted
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalCost(task).netTotalFormatted
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-light d-block table-custom-one__content-wrap",
                                    },
                                    [
                                      _vm.canEditDescription(task)
                                        ? _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: task.quoted_text,
                                                expression: "task.quoted_text",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control--inside-tbl w-100",
                                            attrs: {
                                              placeholder: "Enter Description",
                                            },
                                            domProps: {
                                              value: task.quoted_text,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm._updateTask(task)
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  task,
                                                  "quoted_text",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(task.quoted_text)),
                                          ]),
                                    ]
                                  ),
                                ]),
                                false
                                  ? _c("td", { staticClass: "text-center" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "comment-header__cc__ext pl-2 ml-1",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-ext",
                                            },
                                            [
                                              _vm._l(
                                                task.approvers,
                                                function (u, i) {
                                                  return _c(
                                                    "a",
                                                    {
                                                      key: i,
                                                      staticClass:
                                                        "to-2 avatar avatar-sm rounded-circle text-sm",
                                                      class: _vm.userAvatar(
                                                        u && u.user
                                                      ).bg,
                                                      attrs: {
                                                        href: "javascript:void(0)",
                                                        "data-toggle":
                                                          "tooltip",
                                                        title:
                                                          u.user.first_name +
                                                          " " +
                                                          u.user.last_name,
                                                        "data-target":
                                                          "offcanvascced_int",
                                                        "data-offcanvasfrom":
                                                          "offcanvas",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.selectedTask =
                                                            task
                                                          _vm.modals.approvers = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      !_vm.userAvatar(
                                                        u && u.user
                                                      ).hasImage
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.userAvatar(
                                                                  u && u.user
                                                                ).avatar
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm.userAvatar(
                                                        u && u.user
                                                      ).hasImage
                                                        ? _c("img", {
                                                            attrs: {
                                                              alt: "Image placeholder",
                                                              src: _vm.userAvatar(
                                                                u && u.user
                                                              ).avatar,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "to-3 avatar avatar--38 rounded-circle",
                                                  class:
                                                    _vm.isApproverForTheTaskOrProject(
                                                      task
                                                    )
                                                      ? "bg-success"
                                                      : "bg-gray",
                                                  attrs: {
                                                    href: "javascript:void(0)",
                                                    "data-toggle": "tooltip",
                                                    title: "Add User",
                                                    "data-target":
                                                      "offcanvascced_int",
                                                    "data-offcanvasfrom":
                                                      "offcanvas",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm._onAddApproverClicked(
                                                        task
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-plus text-xs",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("td", {}, [
                                  task.approval_status == "APPROVED" &&
                                  task.payment_status == "SUCCESS" &&
                                  task.id
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center",
                                        },
                                        [_c("span", [_vm._v("Approved")])]
                                      )
                                    : _vm._e(),
                                  task.approval_status == "APPROVED" &&
                                  task.payment_status == "OVERDUE" &&
                                  task.id
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center",
                                        },
                                        [
                                          _c("span", [_vm._v("Approved")]),
                                          _vm.isOverDue(task)
                                            ? _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName:
                                                        "v-tooltip.top-center",
                                                      value: `This task is overdue`,
                                                      expression:
                                                        "`This task is overdue`",
                                                      modifiers: {
                                                        "top-center": true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "d-inline-block icn-notification position-relative font-size-zero lh-1 mb-2",
                                                  attrs: {
                                                    href: "javascript:void(0);",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm._onInvoiceClicked(
                                                        task
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "icn-badge bg-alert",
                                                    },
                                                    [_vm._v("1")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.project.payment_status != "SUCCESS" &&
                                  task.approval_status != "APPROVED" &&
                                  ((task.approver &&
                                    task.approvers.some(
                                      (a) => a.user.id == _vm.profile.id
                                    )) ||
                                    (_vm.project.approvers &&
                                      _vm.project.approvers.some(
                                        (a) => a.user.id == _vm.profile.id
                                      )))
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center",
                                        },
                                        [
                                          _c("base-checkbox", {
                                            staticClass: "adwe",
                                            model: {
                                              value: task.approval_checked,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  task,
                                                  "approval_checked",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "task.approval_checked",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-right 33 d-flex justify-content-end",
                                  },
                                  [
                                    _vm.shouldShowMenu(task)
                                      ? _c(
                                          "base-dropdown",
                                          {
                                            staticClass: "dropdown--dot",
                                            attrs: {
                                              "has-toggle": false,
                                              "title-classes":
                                                "btn-dot-action text-default border-0  mb-0 mr-0",
                                              "menu-on-right": "",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "title" }, [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-ellipsis-v text-xs",
                                              }),
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "d-flex w-100" },
                                              [
                                                _vm.canDelete(task)
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item d-flex alig-items-center lh-1",
                                                        attrs: {
                                                          href: "javascript:void(0);",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm._onDeleteTaskClicked(
                                                              task
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-minus-circle mr-2 fas--sm text-danger",
                                                        }),
                                                        _vm._v(
                                                          "\n                      Delete"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isOverDue(task)
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item d-flex alig-items-center lh-1",
                                                        attrs: {
                                                          href: "javascript:void(0);",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm._onInvoiceClicked(
                                                              task
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-credit-card mr-2 fas--sm text-success",
                                                        }),
                                                        _vm._v(
                                                          "\n                      Update Billing"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          _c("tr", [
                            _vm._m(5),
                            _c("td", { staticClass: "text-right" }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(_vm.selectedBudget.currency) +
                                    _vm._s(
                                      _vm.selectedBudget.bracketFeeFormatted
                                    )
                                ),
                              ]),
                            ]),
                            _c("td", { staticClass: "align-middle" }),
                            _c("td", { staticClass: "align-middle" }),
                            _c("td", { staticClass: "align-middle" }),
                            _c("td", {
                              staticClass: "text-center",
                              attrs: { colspan: "1" },
                            }),
                            _c("td", { staticClass: "align-middle" }),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "align-middle",
                                attrs: { colspan: "12" },
                              },
                              [
                                _vm.isApproverForTheProject
                                  ? _c(
                                      "base-button",
                                      {
                                        staticClass: "btn-sm",
                                        attrs: { outline: "", type: "success" },
                                        on: {
                                          click: _vm._onNewRequirementClicked,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  + Add Task\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _vm._m(6),
                            _c("td", { staticClass: "text-right" }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(_vm.projectBudget.currency) +
                                    _vm._s(_vm.projectBudget.cost)
                                ),
                              ]),
                            ]),
                            _c("td", { staticClass: "align-middle" }),
                            _c("td", { staticClass: "align-middle" }),
                            _c("td", { staticClass: "align-middle" }),
                            _c(
                              "td",
                              { staticClass: "text-center" },
                              [
                                _vm.project.payment_status == "PENDING" &&
                                _vm.isApproverForTheProject
                                  ? _c("base-checkbox", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.center",
                                          value: `Approve`,
                                          expression: "`Approve`",
                                          modifiers: { center: true },
                                        },
                                      ],
                                      model: {
                                        value: _vm.selectAll,
                                        callback: function ($$v) {
                                          _vm.selectAll = $$v
                                        },
                                        expression: "selectAll",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c("td"),
                          ]),
                          _vm.approvalSelectedTasks &&
                          _vm.approvalSelectedTasks.length > 0
                            ? _c("tr", [
                                _vm._m(7),
                                _c("td", { staticClass: "text-right" }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.selectedBudget.currency) +
                                          _vm._s(_vm.selectedBudget.cost)
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("td", { staticClass: "align-middle" }),
                                _c("td", { staticClass: "align-middle" }),
                                _c("td", { staticClass: "align-middle" }),
                                _c("td", {
                                  staticClass: "text-center",
                                  attrs: { colspan: "1" },
                                }),
                                _c("td", { staticClass: "align-middle" }),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-right",
                                attrs: { colspan: "11" },
                              },
                              [
                                _vm.approvalSelectedTasks &&
                                _vm.approvalSelectedTasks.length > 0
                                  ? _c(
                                      "base-button",
                                      {
                                        attrs: { size: "sm", type: "success" },
                                        on: { click: _vm._onApproveClicked },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Approve and Pay\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(" "),
                            ]),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", { attrs: { id: "container-scroll" } }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      {
        staticClass:
          "text-uppercase text-muted text-xxs font-weight-bold bg-light text-center",
        staticStyle: { "padding-right": "0px", "padding-left": "0px" },
      },
      [
        _c("div", {
          staticClass: "d-flex justify-content-center align-items-center lh-1",
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      {
        staticClass:
          "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
      },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end align-items-center lh-1" },
          [_vm._v("\n                  Cost\n                  ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      {
        staticClass:
          "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
      },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end align-items-center lh-1" },
          [_vm._v("\n                  GST\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      {
        staticClass:
          "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
      },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end align-items-center lh-1" },
          [_vm._v("\n                  Total\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      {
        staticClass:
          "text-uppercase text-muted text-xxs font-weight-bold ps-2 bg-light",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-center align-items-center lh-1",
          },
          [_vm._v("\n                  Approve\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "align-middle", attrs: { colspan: "6" } }, [
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v("Bracket Processing Fee"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "align-middle", attrs: { colspan: "6" } }, [
      _c("span", { staticClass: "font-weight-bold" }, [_vm._v("Total")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "align-middle", attrs: { colspan: "6" } }, [
      _c("span", { staticClass: "font-weight-bold" }, [_vm._v("Approved")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }